import G6, { IG6GraphEvent } from '@antv/g6';
import { GraphBehavior, GraphNodeEvent } from '../constants';
import { selectChildNode } from '../shapes';
import { Behavior, Graph, Node } from '../types';
import { normalizeNodeEventData, select } from '../utils';

interface DoubleClickNodeBehavior extends Behavior {
  /** Handle mouse enter */
  handleNodeDblClick(e: IG6GraphEvent): void;
}

const doubleClickNodeBehavior: DoubleClickNodeBehavior = {
  getEvents() {
    return {
      [GraphNodeEvent.onNodeDoubleClick]: 'handleNodeDblClick',
    };
  },

  handleNodeDblClick(e) {
    const { graph } = this;

    if (!graph) return;
    const parsedData = normalizeNodeEventData(e);

    if (e.item) {
      // Makes sure the second click doesn't unselect item
      select(graph as Graph, e.item);
    }
    if (parsedData?.childNodeData && graph) {
      selectChildNode({ node: e.item as Node, graph, index: parsedData.childNodeIndex });
    }
  },
};

G6.registerBehavior(GraphBehavior.DoubleClickNode, doubleClickNodeBehavior);
